<template>
  <el-dialog
    :visible.sync="isModalVisibile"
    class="center-with-menu meeting-canceled"
    custom-class="meeting-canceled__dialog">
    <h3 slot="title" class="meeting-canceled__title">
      {{ $t('home.meeting.meetingCanceled.title') }}
    </h3>
    <el-form label-position="top" ref="form" :model="form">
      <el-form-item :label="$t('home.meeting.meetingCanceled.reason')">
        <el-select
          v-model="form.reason"
          class="meeting-canceled__reason"
          :placeholder="$t('home.meeting.meetingCanceled.reason')">
          <el-option
            :label="$t('home.meeting.meetingCanceled.reasons.unavailable')"
            value="unavailable">
          </el-option>
          <el-option
            :label="$t('home.meeting.meetingCanceled.reasons.moverFound')"
            value="mover_found">
          </el-option>
          <el-option
            :label="$t('home.meeting.meetingCanceled.reasons.reported')"
            value="reported">
          </el-option>
          <el-option
            :label="$t('home.meeting.meetingCanceled.reasons.canceled')"
            value="canceled">
          </el-option>
          <el-option
            :label="$t('home.meeting.meetingCanceled.reasons.other')"
            value="other">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('home.meeting.meetingCanceled.comment.text')">
        <el-input
          type="textarea"
          :rows="4"
          :placeholder="$t('home.meeting.meetingCanceled.comment.placeholder')"
          v-model="form.comment">
        </el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="meeting-canceled__footer">
      <el-button
        @click="isModalVisibile = false">
        {{ $t('home.meeting.meetingCanceled.return') }}
      </el-button>
      <el-button
        type="primary"
        :disabled="isCancelLoading"
        :loading="isCancelLoading"
        @click="cancelMeeting">
        {{ $t('home.meeting.meetingCanceled.cancel') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  props: {
    isVisible: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      form: {
        reason: 'unavailable',
        comment: '',
      },
    };
  },
  computed: {
    ...mapGetters({
      isCancelLoading: 'projectStore/isCancelLoading',
    }),
    isModalVisibile: {
      get() {
        return this.isVisible;
      },
      set(visible) {
        this.$emit('update:is-visible', visible);
      },
    },
  },
  methods: {
    ...mapActions({
      deleteMeeting: 'projectStore/deleteMeeting',
    }),
    async cancelMeeting() {
      try {
        await this.deleteMeeting({
          reason: this.form.reason,
          comment: this.form.comment,
        });
        this.isModalVisibile = false;
      // eslint-disable-next-line no-empty
      } catch (e) {}
    },
  },
};
</script>

<style lang="scss" scoped>
.meeting-canceled {
  text-align: left;
  &__title {
    margin-top: 0;
    margin-bottom: 0;
  }
  &__footer {
    text-align: right;
    .el-button:last-child {
      margin-top: 10px;
    }
  }
  &__reason {
    width: 100%;
  }
}

:deep(.meeting-canceled__dialog) {
  width: 90%;
  margin-top: 5vh !important;
  @include breakpoint(tablet) {
    width: 75%;
  }
}
:deep(.el-dialog__body) {
  padding-top: 10px;
  padding-bottom: 0;

  .el-form-item__label {
    line-height: inherit;
  }
}
</style>
